import { default as Modal } from './AbstractModal'

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = 'has-modal-video-open'

    constructor(m) {
        super(m)

        // UI
        this.$player = this.$('player')[0]
        this.$video = this.$('video')[0]

        // Data
        this.videoSrc = null

        // Binding
        this.onVideoEndedBind = this.onVideoEnded.bind(this)
        this.onTransitionEndBind = this.onTransitionEnd.bind(this)
    }

    ///////////////
    // Callbacks
    ///////////////
    onInit() {
        this.videoPlayerID = this.$player.dataset.moduleVideoPlayer
        window.addEventListener('videoPlayerEnded', this.onVideoEndedBind)
        this.el.addEventListener('transitionend', this.onTransitionEndBind)
    }

    onVideoEnded () {
        this.close()
    }

    onTransitionEnd(e) {
        const property = e.propertyName

        if (property != 'visibility' || this.isOpen) return

        requestAnimationFrame(() => {
            this.call('pause', this.videoPlayerID, 'VideoPlayer')
            this.call('reset', this.videoPlayerID, 'VideoPlayer')
        })
    }

    onOpen(args) {
        // Get video src
        let videoSrc = null

        if (args.srcMobile && window.matchMedia("(max-aspect-ratio: 1/1) and (max-width: 700px)").matches && args.srcMobile != null) {
            videoSrc = args.srcMobile
        } else {
            videoSrc = args.src
        }

        // If no video
        if (videoSrc == null) return

        if (videoSrc != this.videoSrc) {
            // Set video src
            this.$video.src = videoSrc

            // Store video src
            this.videoSrc = videoSrc
        }

        // Close menu
        this.call('close', null, 'ModalMenu')

        // Stop Scroll event
        this.call('stop', null, 'Scroll')

        // Play video
        this.call('play', this.videoPlayerID, 'VideoPlayer')

        // Unmute video
        this.call('progressiveUnmute', this.videoPlayerID, 'VideoPlayer')
    }

    onClose() {
        this.call('start', null, 'Scroll')
        this.call('progressiveMute', this.videoPlayerID, 'VideoPlayer')
    }

}
